import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Documento, Evidenza } from '../../models/data.model';
import { CommonService } from '../../services/common.service';
import { EqualtecService } from '../../services/equaltec.service';

@Component({
  selector: 'app-equaltec-evidence',
  templateUrl: './EqualtecEvidence.component.html'
})
export class EqualtecEvidence implements OnInit {

  public labelNoRecord: boolean = false;
  public isEvidenzAccettata: boolean = false;
  public isEvidenzaPrecedente: boolean = false
  public isCalendar: boolean = false;
  public evidenze: Evidenza[] = [];
  public managedDocument: Documento = {} as Documento;
  public isOkDescrizione: boolean = true;
  public isOkOggetto: boolean = true;
  public OggettoEvidenza: string = "";
  public DescrizioneEvidenza: string = "";
  public buttonEvidenzaActive: boolean = true;
  public calendarModel: NgbDateStruct = {} as NgbDateStruct;
  private selectedDate?: Date;

  constructor(
    public translate: TranslateService,
    private equaltecService: EqualtecService,
    private evidenzaService: CommonService<Evidenza>,
    private creaEvidenzaService: CommonService<string>,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.managedDocument = this.equaltecService.selectedDocument;
    this.isEvidenzaPrecedente = this.equaltecService.isEvidenzaPrecedente
    this.getEvidenze(this.managedDocument)
  }

  getEvidenze = (doc: Documento) => {
    this.labelNoRecord = false;
    let url = ""
    if (this.isEvidenzaPrecedente) {
      url = 'api/rest/GetEvidenzeRevPrecedenteByIdDocumento';
    }
    else {
      url = 'api/rest/GetEvidenzeByIdDocumento';
    }
    const input = { iddocumento: doc.idDocumento };
    this.evidenzaService.postData(url, input, false).subscribe(result => {
      if (result) {
        console.log('this is evidenze : ', result);
        this.evidenze = result as Evidenza[];
        this.evidenze.forEach(evi => {
          if (evi["Stato"] == 2) {
            this.isEvidenzAccettata = true;
          }
        })
        this.labelNoRecord = true;
      }
    });
  }

  onFileSelected(event) {
    this.buttonEvidenzaActive = false;
    const file: File = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("thumbnail", file);
      formData.append("iddocumento", this.managedDocument.idDocumento.toString());
      this.http.post("/api/rest/thumbnail-upload", formData).subscribe(result => {
        this.buttonEvidenzaActive = true;
      }, error => {
        alert("Errore durante l'upload del file");
        this.buttonEvidenzaActive = true;
      });
    }
  }

  onResultClickedEvidenze = () => {
    if (this.DescrizioneEvidenza && this.OggettoEvidenza) {
      this.isOkDescrizione = true;
      this.isOkOggetto = true;
      const send = this.showResultEvidenze();
      return send;
    } else {
      if (!this.DescrizioneEvidenza && this.OggettoEvidenza) {
        this.isOkDescrizione = false;
        this.isOkOggetto = true;
      }
      if (this.DescrizioneEvidenza && !this.OggettoEvidenza) {
        this.isOkOggetto = false;
        this.isOkDescrizione = true;
      }
      if (!this.DescrizioneEvidenza && !this.OggettoEvidenza) {
        this.isOkOggetto = false;
        this.isOkDescrizione = false;
      }
    }
  }

  showResultEvidenze = () => {
    this.labelNoRecord = false;
    const url = 'api/rest/CreaEvidenza';
    let selectedDateString: string;
    if (this.selectedDate != null && this.selectedDate != undefined) {
      // Converte selectedDate in stringa ISO 8601 (basata su UTC) per una serializzazione consistente per Arcadoc
      selectedDateString = this.selectedDate.toISOString();
    } else {
      selectedDateString = "";
    }
    const input = {
      descrizione: this.DescrizioneEvidenza,
      oggetto: this.OggettoEvidenza,
      iddocumento: this.managedDocument.idDocumento.toString(),
      destinatari: this.managedDocument.idCommittente.toString(),
      datascadenza: selectedDateString
    };
    this.creaEvidenzaService.postData(url, input, false).subscribe(result => {
      if (result['risultato'] == "OK") {
        this.OggettoEvidenza = "";
        this.DescrizioneEvidenza = "";
        this.isCalendar = false;
        console.log("result" + result)
        alert("Evidence created");
        /* Refresh della lista Evidenze */
        const url = 'api/rest/GetEvidenzeByIdDocumento';
        const input = { iddocumento: this.managedDocument.idDocumento.toString() };
        this.evidenzaService.postData(url, input, false).subscribe(result => {
          if (result) {
            this.evidenze = result as Evidenza[];
            this.labelNoRecord = true;
          }
        })
      } else {
        alert("an error occurred during the creation of the evidence");
      }
    })
  }

  openCalendar = () => {
    this.isCalendar = !this.isCalendar;
  }

  selectDate = () => {
    let now = new Date();
    this.selectedDate = new Date(this.calendarModel.year, this.calendarModel.month - 1, this.calendarModel.day, now.getHours(), now.getMinutes(), 0, 0);
  }

}